// extracted by mini-css-extract-plugin
module.exports = {"box":"activityPage_box_yK8L8","page":"activityPage_page_5nJuI","content":"activityPage_content_ZRWI1","bindMask":"activityPage_bindMask_2GfJe"};